import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Static API reference for the curated Developer API (docs/KONZEPT-Developer-Platform.md).
 * Hand-written content covering exactly what Portal.DevFunctions exposes today — the
 * OpenAPI-generated version (GET /api/v1/openapi.json driving this page) is a later
 * iteration, not built yet, see the concept doc's Umsetzungsschritte.
 */
@Component({
    selector: 'app-docs',
    templateUrl: './docs.page.html',
    styleUrls: ['./docs.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        IonicModule,
        RouterLink,
        TranslatePipe,
    ],
})
export class DocsPage { }
